import WhatsNext from "@/components/WhatsNext";
import SEO from "@/components/SEO";

const Roadmap = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <SEO 
        title="Upcoming 2025 - Upcoming Features | Oraculus:X Crypto Trading Platform"
        description="Discover what's next for Oraculus:X: AI portfolio optimization, automated trading bot, mobile app, and more innovative features coming soon."
      />
      <div className="fixed inset-0 bg-gradient-mesh animate-mesh-move opacity-40" />
      <div className="fixed inset-0 bg-gradient-opal-radial animate-gradient-shift" style={{ backgroundSize: '200% 200%' }} />
      
      <main className="relative z-10 pt-20 md:pt-32">
        <WhatsNext />
      </main>
    </div>
  );
};

export default Roadmap;
